// Centralized version configuration
// Update this file when releasing new versions to keep Footer and ReleaseNotes in sync

export const APP_VERSION = '1.10.2';
export const RELEASE_DATE = '2026-07-08';
export const RELEASE_TYPE = 'patch';
export const RELEASE_TITLE = 'Scheduling Consistency Fixes';

// Helper to get version info for components
export const getVersionInfo = () => ({
  version: APP_VERSION,
  date: RELEASE_DATE,
  type: RELEASE_TYPE,
  title: RELEASE_TITLE,
  fullVersion: `v${APP_VERSION}`
});

export default {
  APP_VERSION,
  RELEASE_DATE,
  RELEASE_TYPE,
  RELEASE_TITLE,
  getVersionInfo
};
